<div class="home-user-bg" *ngIf="data; else loading" [class.border]="edit">
  <div class="row pt-5">
    <div class="col">
      <div class="text-primary welcome-style" translate>WELCOME_TO_COLMEC_B2B</div>
      <div class="welcome-user-style" *ngIf="currentUser && currentUser.name">
        <span translate>{{ currentUser.name }}</span
        ><span>!</span>
      </div>
    </div>
  </div>

  <div class="row mt-5 mb-3">
    <div class="col">
      <div class="text-primary medium-size-text bolder" (click)="edit ? openModal('block1_big_text1') : ''" translate>
        {{ getText(data.elements?.block1_big_text1?.text) }}
      </div>
      <span class="text-primary" (click)="edit ? openModal('block1_normal_text1') : ''" translate>
        {{ getText(data.elements?.block1_normal_text1?.text) }} </span
      >&nbsp;
      <span class="text-danger" (click)="edit ? openModal('block1_normal_red_text1') : ''" translate>
        {{ getText(data.elements?.block1_normal_red_text1?.text) }}
      </span>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <lib-filter-list #productList [configService]="colmecTopProductListByIdsConfigService"></lib-filter-list>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col">
      <h2 class="text-primary font-weight-bold" translate>LAST_ORDERS</h2>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <lib-filter-list [configService]="colmecLastOrderListConfigService"></lib-filter-list>
    </div>
  </div>

  <div
    class="colmec-blue-bg-img d-flex justify-content-center"
    [style.backgroundImage]="'url(' + getImage(data.elements?.block2_big_text1?.image) + ')'"
  >
    <div class="d-flex align-items-center">
      <div class="text-center">
        <div class="big-title-text" translate>
          <div (click)="edit ? openModal('block2_big_text1') : ''" translate>
            {{ getText(data.elements?.block2_big_text1?.text) }}
          </div>
          <div (click)="edit ? openModal('block2_big_text2') : ''" translate>
            {{ getText(data.elements?.block2_big_text2?.text) }}
          </div>
        </div>
        <div class="subtitle-text" (click)="edit ? openModal('block2_normal_text1') : ''" translate>
          {{ getText(data.elements?.block2_normal_text1?.text) }}
        </div>
        <div class="subtitle-text" (click)="edit ? openModal('block2_normal_text2') : ''" translate>
          {{ getText(data.elements?.block2_normal_text2?.text) }}
        </div>
        <button
          class="btn btn-sm text-primary text-uppercase discovery-premium"
          (click)="edit ? openModal('block2_button_1') : navigateTo(data.elements?.block2_button_1.link)"
          translate
        >
          {{ getText(data.elements?.block2_button_1?.text) }}
        </button>
      </div>
    </div>
  </div>

  <!-- <div class="description-block3">
    <div class="col-12 medium-size-text px-0 bolder text-primary" (click)="edit ? openModal('block3_big_text') : '' "
      translate>
      {{getText(data.elements?.block3_big_text?.text)}}
    </div>
    <div class="col-12 px-0 text-primary" (click)="edit ? openModal('block3_normal_text') : '' " translate>
      {{getText(data.elements?.block3_normal_text?.text)}}
    </div>
    <div class="btns-row">
      <button class="btn btn-sm text-uppercase blue-button" *ngIf="!onlyUserPermission" [routerLink]="['/customers/']"
        translate>
        MANAGE_CUSTOMERS
      </button>
      <button class="btn btn-sm text-uppercase red-button" [routerLink]="['/open-orders/']" translate>
        MANAGE_ORDERS
      </button>
    </div>

  </div> -->
</div>

<ng-template #loading translate> LOADING </ng-template>
